import type { RouteType } from './types/route-type';

// Die Module, die eine Sub-Route bekommen.
export const MODULES_WITH_SUB_ROUTES: ReadonlyArray<string> = ['administration', 'usermanagement', 'furnport'];

// Die Route, die zum gezeigten content gehoert: das Modul und die Sub-Route, die es zuletzt gemeldet
// hat oder die zuletzt aus der URL kam.
export function routeOfContent(content: string, moduleRoutes: Readonly<Record<string, string>>): RouteType {
  const subRoute = MODULES_WITH_SUB_ROUTES.includes(content) ? (moduleRoutes[content] ?? '') : '';
  return { module: content, subRoute: subRoute };
}
